export default __webpack_public_path__ + "static/cryptovoxels-d6e7b8a6c696f540b8a0dbc952440866.png";